// Compiled at 2026-10-07T06:21:14.844Z
import * as LowgileDataUtil from "@lg/shared";
import * as Ramda from "ramda";
import * as $Modules from "../../Module/$modules.js";
import { Toolbox, Toolbox as This, System, Common } from "../../Module/$modules.js";
import type { HasId, IdType, Class, DeepReadonly, NominalType } from "@lg/shared";
import { Sys, ExecutionService } from "@lg/ng-shared";
// Auto-generated by Lowgile
import { Component, OnInit, AfterViewInit, Input, Output, EventEmitter, ChangeDetectionStrategy, inject, input, signal, computed, effect, linkedSignal, viewChild } from "@angular/core";
import { NavigationSkipped } from "@angular/router";
import { AppState, app } from "../../ClientDataStore/$state";
import { AbstractScreen } from "@lg/ng-shared";
import { ValidationRules, BoInfoSymbol } from "@lg/shared";
import { ProxyTargetSymbol } from "@lg/shared";
import { Semaphore } from "@lg/shared";
import { memoize } from "@lg/shared";
import { combineLatest, filter } from "rxjs";
import { takeUntilDestroyed } from "@angular/core/rxjs-interop";
import { ProcessTaskComponent } from "../../components/process-task.component";
import { proxySignal, ProxySignal } from "../../signals.js";

interface Properties {
    gs: This.GoalSetting;
    goal: This.GoalSettingGoal;
    viewMode: This.GoalSettingViewMode;
    columnVisibility: This.GoalSettingGoalColumnVisibility;
}

interface State {
    app: AppState;
    screen: Properties;
}

@Component({
    selector: 'Toolbox-GoalSettingGoalInclude',
    templateUrl: './GoalSettingGoalInclude.html',
    styleUrls: ['./GoalSettingGoalInclude.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class GoalSettingGoalInclude extends AbstractScreen implements OnInit, AfterViewInit {
    static readonly $canBeMainScreen = true;
    static readonly $canBeDialogScreen = true;
    readonly $qualifiedScreenName = 'Toolbox.GoalSettingGoalInclude';
    $isDialog = false;
    $Modules = $Modules;
    Toolbox = Toolbox;
    System = System;
    Common = Common;
    Sys = Sys;
    This = This;
    app = app;
    $scope = {};
    $pathSegments: string[] = [];
    $processTaskComponent = inject(ProcessTaskComponent, { optional: true });
    output = {

    };
    $validators: Record<number, ValidationRules> = {
        12: {
            sync: [($value: any, $scope: any) => {
                const { app, screen, $pathSegments, $disabled } = $scope

                if ($value?.[BoInfoSymbol]?.boType == 'StaticEntity') {
                    if ($value.id) return undefined
                } else {
                    if ($value) return undefined
                    if ($value === 0) return undefined
                }
                return {
                    error: Common.$T.validationRequired,
                    ruleId: 'isRequired',
                }

            }],
            async: [],
        },
        7: {
            sync: [($value: any, $scope: any) => {
                const { app, screen, $pathSegments, $disabled } = $scope

                if ($value?.[BoInfoSymbol]?.boType == 'StaticEntity') {
                    if ($value.id) return undefined
                } else {
                    if ($value) return undefined
                    if ($value === 0) return undefined
                }
                return {
                    error: Common.$T.validationRequired,
                    ruleId: 'isRequired',
                }

            }],
            async: [],
        },
        34: {
            sync: [($value: any, $scope: any) => {
                const { app, screen, $pathSegments, $disabled } = $scope

                if ($value?.[BoInfoSymbol]?.boType == 'StaticEntity') {
                    if ($value.id) return undefined
                } else {
                    if ($value) return undefined
                    if ($value === 0) return undefined
                }
                return {
                    error: Common.$T.validationRequired,
                    ruleId: 'isRequired',
                }

            }],
            async: [],
        }
    };
    input_gs = input(undefined, { alias: 'gs' });
    var_gs = proxySignal<This.GoalSetting>(undefined as any);
    input_goal = input(undefined, { alias: 'goal' });
    var_goal = proxySignal<This.GoalSettingGoal>(undefined as any);
    input_viewMode = input(undefined, { alias: 'viewMode' });
    var_viewMode = proxySignal<This.GoalSettingViewMode>(undefined as any);
    input_columnVisibility = input(undefined, { alias: 'columnVisibility' });
    var_columnVisibility = proxySignal<This.GoalSettingGoalColumnVisibility>(undefined as any);
    readonly screen =
        ((component: typeof this) => {
            return {
                get gs() { return component.var_gs() },
                set gs(value: This.GoalSetting) { component.var_gs.set(value) },
                get goal() { return component.var_goal() },
                set goal(value: This.GoalSettingGoal) { component.var_goal.set(value) },
                get viewMode() { return component.var_viewMode() },
                set viewMode(value: This.GoalSettingViewMode) { component.var_viewMode.set(value) },
                get columnVisibility() { return component.var_columnVisibility() },
                set columnVisibility(value: This.GoalSettingGoalColumnVisibility) { component.var_columnVisibility.set(value) }
            }
        })(this)
        ;

    get $inputs() {
        return {
            gs: this.screen.gs,
            goal: this.screen.goal,
            viewMode: this.screen.viewMode,
            columnVisibility: this.screen.columnVisibility
        }
    }

    async ngOnInit(): Promise<void> {
        super.ngOnInit()
        if (!this.$processTaskComponent) {
            this.processService.tokenId.set(undefined)
        }


    }

    async ngAfterViewInit(): Promise<void> {
    }

    constructor() {

        super()

        effect(() => {
            if (!this.authService.isInitialized()) return
            const isVariablesInitialized = this.$isVariablesInitialized()
            const { screen, app } = this

            const new_gs = this.dialogData?.data?.gs ?? this.input_gs() ?? (undefined)
            if (new_gs !== undefined) this.screen.gs = new_gs


            const new_goal = this.dialogData?.data?.goal ?? this.input_goal() ?? (undefined)
            if (new_goal !== undefined) this.screen.goal = new_goal


            const new_viewMode = this.dialogData?.data?.viewMode ?? this.input_viewMode() ?? (undefined)
            if (new_viewMode !== undefined) this.screen.viewMode = new_viewMode


            const new_columnVisibility = this.dialogData?.data?.columnVisibility ?? this.input_columnVisibility() ?? (undefined)
            if (new_columnVisibility !== undefined) this.screen.columnVisibility = new_columnVisibility

            this.$isVariablesInitialized.set(true)
        })

        effect(() => {
            if (!this.$isVariablesInitialized()) return
            if (!this.$isOnInitCalled) {
                this.$isOnInitCalled = true
                setTimeout(async () => {
                    await this.action_onInit()
                    this.$isFullyInitialized.set(true)
                })
            }
        })



    }

    async action_onInit($event?: any) {
        const { app, screen, output } = this
        {

        }
    }
}
